"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseParameterComponent = void 0;
/**
 * Slugification (:D) of a given value.
 * @returns {String} The slugified string
 */
var _slugify = (function () {
    /* eslint-disable */
    var charMap = JSON.parse('{"$":"dollar","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","џ":"dz","Ґ":"G","ґ":"g","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","‘":"\'","’":"\'","“":"\\"","”":"\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₹":"indian rupee","₽":"russian ruble","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial"}');
    /* eslint-enable */
    function replace(string, options) {
        if (options === void 0) { options = null; }
        if (typeof string !== "string")
            string = string + "";
        options =
            typeof options === "string" ? { replacement: options } : options || {};
        var slug = string
            .split("")
            .reduce(function (result, ch) {
            return (result +
                (charMap[ch] || ch)
                    // allowed
                    .replace(options.remove || /[^\w\s$*_+~.()''!\-:@]/g, ""));
        }, "")
            // trim leading/trailing spaces
            .replace(/^\s+|\s+$/g, "")
            // convert spaces
            .replace(/[-\s]+/g, options.replacement || "-")
            // remove trailing separator
            .replace("#{replacement}$", "");
        return options.lower ? slug.toLowerCase() : slug;
    }
    replace.extend = function (customMap) {
        for (var key in customMap) {
            charMap[key] = customMap[key];
        }
    };
    return replace;
})();
var BaseParameterComponent = /** @class */ (function () {
    // #endregion Properties (10)
    // #region Constructors (1)
    function BaseParameterComponent(_api, _domManager, _queue, _component, _parameter, _editMode) {
        var _this = this;
        this._api = _api;
        this._domManager = _domManager;
        this._queue = _queue;
        this._component = _component;
        this._parameter = _parameter;
        this._editMode = _editMode;
        this._editClass = "sdv-edit-label";
        this._wrapClass = "uk-text-truncate";
        this._slugId = this._api.getRuntimeId() + "_" + _slugify(_component.id);
        this._component.hidden = this._component.hidden || false;
        this._component.parameterDefinition.update = this.updateAsync.bind(this);
        // Static calls. Not every model needs to be bound to events, so it's done in this way.
        BaseParameterComponent._instances.push(this);
        if (!BaseParameterComponent._eventsBound) {
            this._api.parameters.addEventListener(this._api.parameters.EVENTTYPE.VALUE_UPDATE, function (event) { return BaseParameterComponent === null || BaseParameterComponent === void 0 ? void 0 : BaseParameterComponent._instances.forEach(function (x) { return x.handleValueUpdateEvent(event); }); });
            this._api.parameters.addEventListener(this._api.parameters.EVENTTYPE.UPDATE, function (event) { return BaseParameterComponent === null || BaseParameterComponent === void 0 ? void 0 : BaseParameterComponent._instances.forEach(function (x) { return x.handleParameterUpdateEvent(event); }); });
            this._api.exports.addEventListener(this._api.exports.EVENTTYPE.UPDATE, function (event) { return BaseParameterComponent === null || BaseParameterComponent === void 0 ? void 0 : BaseParameterComponent._instances.forEach(function (x) { return x.handleExportsUpdateEvent(event); }); });
            BaseParameterComponent._eventsBound = true;
        }
        // Static, keep only single reference to queue instance
        if (!BaseParameterComponent._queueInstance) {
            BaseParameterComponent._queueInstance = _queue;
            BaseParameterComponent._queueInstance.onQueuePassFinished(function () { return __awaiter(_this, void 0, void 0, function () {
                var p;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            p = [];
                            BaseParameterComponent._toExecuteOnQueuePassFinished.forEach(function (x) {
                                p.push({ id: x.id, value: x.value });
                            });
                            return [4 /*yield*/, this._api.parameters.updateAsync(p)];
                        case 1: return [4 /*yield*/, (_a.sent()).data];
                        case 2:
                            (_a.sent());
                            // clear 
                            BaseParameterComponent._toExecuteOnQueuePassFinished.length = 0;
                            return [2 /*return*/];
                    }
                });
            }); });
        }
        this.editMode(this._editMode);
    }
    Object.defineProperty(BaseParameterComponent.prototype, "children", {
        // #endregion Constructors (1)
        // #region Public Accessors (24)
        get: function () {
            return this._component.children;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseParameterComponent.prototype, "hidden", {
        get: function () {
            return this._component.hidden;
        },
        set: function (v) {
            this._component.hidden = v;
            if (this._editMode) {
                if (this.inputComponent) {
                    v ? this.inputComponent.classList.add('sdv-hidden') : this.inputComponent.classList.remove('sdv-hidden');
                }
            }
            else {
                if (v) {
                    this.destroy();
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseParameterComponent.prototype, "id", {
        get: function () {
            return this._component.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseParameterComponent.prototype, "inContentEditMode", {
        get: function () {
            return this._inContentEditMode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseParameterComponent.prototype, "inputComponent", {
        get: function () {
            return this._component.inputComponent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseParameterComponent.prototype, "inputContainer", {
        get: function () {
            return this._component.inputContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseParameterComponent.prototype, "isChanged", {
        get: function () {
            return this._component.isChanged;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseParameterComponent.prototype, "isExport", {
        get: function () {
            return this._parameter.isParameter !== true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseParameterComponent.prototype, "isParameter", {
        get: function () {
            return this._parameter.isParameter;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseParameterComponent.prototype, "label", {
        get: function () {
            return this._component.label;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseParameterComponent.prototype, "name", {
        get: function () {
            return this._parameter.name;
        },
        set: function (v) {
            this._parameter.name = v;
            this._component.label.innerHTML = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseParameterComponent.prototype, "newName", {
        get: function () {
            return this._newName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseParameterComponent.prototype, "order", {
        get: function () {
            return this._component.order;
        },
        set: function (val) {
            this._component.order = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseParameterComponent.prototype, "parameterDefinition", {
        get: function () {
            return this._component.parameterDefinition;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseParameterComponent.prototype, "row", {
        get: function () {
            return this._component.row;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseParameterComponent.prototype, "size", {
        get: function () {
            return this._component.size;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseParameterComponent.prototype, "type", {
        get: function () {
            return this._component.type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseParameterComponent.prototype, "value", {
        get: function () {
            return this._component.value;
        },
        set: function (v) {
            this._component.value = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseParameterComponent.prototype, "valueStack", {
        get: function () {
            return this._component.valueStack;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseParameterComponent.prototype, "wasEdited", {
        get: function () {
            return this._wasEdited;
        },
        enumerable: false,
        configurable: true
    });
    // #endregion Public Accessors (24)
    // #region Public Methods (10)
    BaseParameterComponent.prototype.destroy = function () {
        this._component.destroy();
    };
    BaseParameterComponent.prototype.handleExportsUpdateEvent = function (event) {
        var parameter = event.export[this.id];
        if (!parameter) {
            if (event.export.id === this.id) {
                parameter = event.export;
            }
        }
        if (!parameter)
            return;
        this.hidden = parameter.hidden;
    };
    BaseParameterComponent.prototype.handleParameterUpdateEvent = function (event) {
        var parameter = event.parameter[this.id];
        if (!parameter) {
            if (event.parameter.id === this.id) {
                parameter = event.parameter;
            }
        }
        if (!parameter)
            return;
        this.hidden = parameter.hidden;
    };
    BaseParameterComponent.prototype.handleValueUpdateEvent = function (event) {
        if (event.parameter) {
            var pluginKeys = Object.keys(event.parameter);
            for (var i = 0; i < pluginKeys.length; i++) {
                var pluginKey = pluginKeys[i];
                var parametersKeys = Object.keys(event.parameter[pluginKey]);
                for (var j = 0; j < parametersKeys.length; j++) {
                    var parameterKey = parametersKeys[j];
                    if (parameterKey === this.id) {
                        this.value = event.parameter[pluginKey][parameterKey];
                        break;
                    }
                }
            }
        }
    };
    BaseParameterComponent.prototype.insertBefore = function (other) {
        this._component.insertBefore(other);
    };
    BaseParameterComponent.prototype.isCurrentValueSameAsInital = function () {
        return this._component.isCurrentValueSameAsInital();
    };
    /**
     * Add on destroy listener
     * @param { () => void } cb
     * @return void
     */
    BaseParameterComponent.prototype.onDestroy = function (cb) {
        this._component.onDestroy(cb);
    };
    BaseParameterComponent.prototype.queueCommitExecuted = function (val, event) {
        this._component.queueCommitExecuted(val, event);
    };
    /**
     * Sets component into editable mode
     * @param { boolean } val
     * @return { void }
     */
    BaseParameterComponent.prototype.setEditable = function (val) {
        var _this = this;
        if (val) {
            this.label.classList.remove(this._wrapClass);
            this.label.classList.add(this._editClass);
            this.label.addEventListener("input", function (event) {
                _this._wasEdited = true;
                _this._newName = event.target.innerText;
            });
            this.label.contentEditable = "true";
        }
        else {
            this.label.classList.remove(this._editClass);
            this.label.classList.add(this._wrapClass);
            this.label.contentEditable = "false";
        }
        this._inContentEditMode = val;
    };
    BaseParameterComponent.prototype.setToInitalValueAndClearStack = function () {
        return this._component.setToInitalValueAndClearStack();
    };
    // #endregion Public Methods (10)
    // #region Protected Methods (1)
    BaseParameterComponent.prototype.updateAsync = function (val) {
        return __awaiter(this, void 0, void 0, function () {
            var promise;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._parameter.isParameter) return [3 /*break*/, 4];
                        if (!!this._queue.executing) return [3 /*break*/, 2];
                        promise = this._api.parameters.updateAsync({ id: this._parameter.id, value: val });
                        // this way,with usage of BaseParameterComponent update events from viewer can be awaited.
                        BaseParameterComponent.parametersPromises[this.id] = promise;
                        return [4 /*yield*/, BaseParameterComponent.parametersPromises[this.id]];
                    case 1:
                        _a.sent();
                        delete BaseParameterComponent.parametersPromises[this.id];
                        return [3 /*break*/, 3];
                    case 2:
                        // small optimization. Don't request same values.
                        BaseParameterComponent._toExecuteOnQueuePassFinished.push({ id: this._parameter.id, value: val });
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4: return [2 /*return*/, this._api.exports.requestAsync({ id: this._parameter.id })];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    // #endregion Protected Methods (1)
    // #region Private Methods (1)
    BaseParameterComponent.prototype.editMode = function (val) {
        var _this = this;
        if (val) {
            this.label.classList.add("sdv-edit-mode");
            this._hideIcon = this._domManager.createDomElement("i", this._slugId + "-hide-icon", null, ["uk-float-right", "uk-margin-remove", "uk-padding-remove-right", "sdv-control-brand-color"], { "uk-icon": "icon: ban; ratio: 0.6;" });
            this._sortIcon = this._domManager.createDomElement("i", this._slugId + "-sort-icon", null, ["sdv-control-brand-color", "uk-padding-remove-left", "uk-margin-small-right", "jq-sdv-sort-bars", "uk-width-auto"], { "uk-icon": "icon: move; ratio: 0.8;" });
            this._hideIcon.onclick = function () { return _this.hidden = !_this.hidden; };
            this._component.inputContainer.classList.remove("uk-width-1-1");
            this._component.inputContainer.classList.add("uk-width-expand");
            var hideIconDiv = this._domManager.createDomElement("div", null, null, ["uk-width-1-1"]);
            hideIconDiv.appendChild(this._hideIcon);
            if (this._component.type === "button" /* BUTTON */) {
                this.row.insertBefore(hideIconDiv, this.row.childNodes[0]);
                this.row.insertBefore(this._sortIcon, this.inputContainer);
            }
            else {
                this.row.insertBefore(hideIconDiv, this.label);
                this.row.insertBefore(this._sortIcon, this.inputContainer);
            }
        }
    };
    BaseParameterComponent._eventsBound = false;
    BaseParameterComponent._instances = [];
    /** @var _toExecuteOnQueuePassFinished - array of parameters to be executed when to on queue pass finished is called. updateValue goes to updateAsync, ui is updated value */
    BaseParameterComponent._toExecuteOnQueuePassFinished = [];
    BaseParameterComponent.parametersPromises = {};
    return BaseParameterComponent;
}());
exports.BaseParameterComponent = BaseParameterComponent;
